import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <div className="text-center">
                <div className="overline">Error 404</div>
                <h1 className="font-editorial text-[56px] tracking-editorial mt-4">This page is off the map.</h1>
                <Link to="/" className="mt-8 inline-block border border-brand-navy bg-brand-navy text-white px-6 py-3 text-[13.5px] hover-invert hover:bg-brand-gold hover:text-brand-navy">
                    Back to home
                </Link>
            </div>
        </div>
    );
}
